let html = `<div class="selectbox-item selectbox-item--icon selector">
    <div class="selectbox-item__icon">{icon}</div>
    <div>
        <div class="selectbox-item__title">{title}</div>
        <div class="selectbox-item__subtitle">{subtitle}</div>
    </div>
</div>`

export default html